import { useState, useEffect, useRef } from 'react'
import TextField from '@mui/material/TextField'

const AnimatedPlaceholderTextField = ({ 
  disableAnimation, 
  placeholderPhrases, 
  showX,
  placeholder,
  ...props
}) => {
  // const placeholder = useTypingAnimation(!!disableAnimation, placeholderPhrases)

  return (
    <TextField
      {...props}
      variant="filled"
      InputProps={{
        ...props.InputProps,
        type: showX ? 'search' : undefined, // TODO: custom x button
        onKeyPress: e => {
          if (e.target.value?.length > 100) {
            e.preventDefault()
            e.stopPropagation()
          }
        },
        placeholder,
      }}
      {...props.textfieldProps}
    />
  )
}

export default AnimatedPlaceholderTextField